module.exports = __webpack_public_path__ + "img/pass.b0338292.png";